import React from 'react'
import {
  DraggerStyle,
  DraggerUploadComponent,
  UploadStyledButton,
  WarningText
} from './styledComponents'
import { notification, Button } from 'antd'
import DragIcon from '../../../../Assets/Icons/DragIcon'
import PictureUploadIcon from '../../../../Assets/Icons/PictureUploadIcon'
import ImgCrop from 'antd-img-crop'

const MAX_FILE_SIZE_MB = 2
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024
const ALLOWED_FILE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp']

const DraggerComponent = ({
  setSelectedFile,
  saveProfilePicture,
  uploadLoading
}) => {
  const validateFile = file => {
    const isValidType = ALLOWED_FILE_TYPES.includes(file.type)
    const isValidSize = file.size <= MAX_FILE_SIZE_BYTES

    if (!isValidType) {
      notification['error']({
        message: 'Invalid File Type',
        description: 'You can only upload images of JPG, JPEG, PNG, or WebP format'
      })
      return false
    }

    if (!isValidSize) {
      notification['error']({
        message: 'File Too Large',
        description: `File size must be less than ${MAX_FILE_SIZE_MB}MB. Your file is ${(file.size / (1024 * 1024)).toFixed(2)}MB`
      })
      return false
    }

    return true
  }

  const props = {
    name: 'file',
    multiple: false,
    showUploadList: false,
    customRequest: () => {},

    beforeUpload: (file, fileList) => {
      setSelectedFile(file)
      const formData = new FormData()
      formData.append('multipartFile', file)
      saveProfilePicture(formData)
      return false
    }
  }

  const imgCropProps = {
    rotate: true,
    beforeCrop: validateFile
  }

  return (
    <>
      <DraggerUploadComponent>
        <ImgCrop {...imgCropProps}>
          <UploadStyledButton {...props}>
            <Button icon={<PictureUploadIcon />} loading={uploadLoading} />
          </UploadStyledButton>
        </ImgCrop>
        <ImgCrop {...imgCropProps}>
          <DraggerStyle {...props}>
            <div>
              <p className='ant-upload-drag-icon'>
                <DragIcon />
              </p>
            </div>
            <div>
              <p className='ant-upload-text'>Drag & drop your image</p>
            </div>
          </DraggerStyle>
        </ImgCrop>
      </DraggerUploadComponent>
      <WarningText>Max file size: 2MB. Allowed formats: JPG, JPEG, PNG, WebP</WarningText>
    </>
  )
}

export default DraggerComponent
